import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import logger from "../common/utilities/logger/index.js";
import ROUTE_CONSTANTS from "common/constants/route";
import { isEmpty } from "lodash";

const QuotingWidgetApp = () => {
    let history = useHistory();

    const { sdkConfig } = useSelector((state) => state.userDetails);

    useEffect(() => {
        if (!isEmpty(sdkConfig) && sdkConfig?.styles) {
            const sdkValue = { ...sdkConfig };

            logger.info("Initialization SalesFunnel Quoting widget", sdkValue);

            history.push(ROUTE_CONSTANTS.PET_FORM);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdkConfig]);

    return <></>;
};

export default QuotingWidgetApp;

QuotingWidgetApp.propTypes = {};
